function formatCurrency(amount: number, currency: string): string {
    return new Intl.NumberFormat('vi-VN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount) + ' '+ currency;
}
export { formatCurrency };